import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Box, Typography, CardContent, Chip } from "@mui/material";
import Card from "@mui/material/Card";
import Arrow from "../../../../Assets/Svg/offersarrow.svg";
import { Styles } from "./styles";
import { showIconByServiceId } from "../../../../helpers/showIconByServiceId";
import DefaultUserPhoto from "../../../../Assets/profile.jpeg";

const TeamCard = ({ data }) => {
    const navigate = useNavigate();
    const [imageError, setImageError] = useState(false);

    const handleImageError = () => {
        setImageError(true);
    };

    const handleClick = () => {
        if (!data.deleted_at) {
            window.open(`/resellers/${data.id}`, "_blank");
        }
        // If deleted_at exists, do nothing (link is disabled)
    };

    // Determine the image source
    const imageSrc = !data.photo || imageError ? DefaultUserPhoto : data.photo;

    return (
        <Styles>
            <Box
                className="item-carosel"
                style={{
                    padding: '0',
                    width: 'auto',
                    minHeight: '300px',
                    position: 'relative',
                    cursor: data.deleted_at ? 'not-allowed' : 'pointer'
                }}
                key={data.id}
                onClick={handleClick}
            >

                {/* Not Active Badge */}
                {data.deleted_at && (
                    <Chip
                        label="Not Available"
                        color="error"
                        size="small"
                        style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            zIndex: 10
                        }}
                    />
                )}

                <div className="final-logo-container" style={{ alignContent: 'center', minHeight: '100px', margin: '0 20px', justifyItems: "center" }}>
                    <img
                        src={imageSrc}
                        alt="panel"
                        onError={handleImageError}
                        style={{
                            border: data.deleted_at ? "1px solid #ff4444" : "1px solid #296D99",
                            borderRadius: "50%",
                            cursor: data.deleted_at ? 'not-allowed' : 'pointer',
                            width: "200px",
                            height: "200px",
                            maxWidth: 200,
                            objectFit: 'contain',
                            ...(data.deleted_at && {
                                filter: 'grayscale(70%)',
                                opacity: 0.6
                            })
                        }}
                    />
                    <Typography
                        sx={{
                            fontSize: `23px`,
                            color: '#ffffff',
                            ...(data.deleted_at && {
                                opacity: 0.6,
                                textDecoration: 'line-through'
                            })
                        }}
                        className="final-logo"
                    >
                        {data.name}
                    </Typography>
                </div>
            </Box>
        </Styles>
    );
};

export default TeamCard;